const Const_BuildView = 'build';
const Const_TestView = 'test';

const CONST_BUILDVIEW = 'build_view';
const CONST_TESTVIEW = 'test_view';

const DEFAULT_VIEW_TIMELINE = CONST_BUILDVIEW;
const DEFAULT_VIEW_ANALYTICS = CONST_BUILDVIEW;
const DEFAULT_VIEW_AUTOMATION = CONST_TESTVIEW;

const TIME_SPAN_TODAY = 'today';
const TIME_SPAN_MONTH = 'month';
const TIME_SPAN_WEEK = 'week';
const TIME_SPAN_RANGE = 'range';

const DEFAULT_TIME_SPAN_FILTER = TIME_SPAN_WEEK;

/*
  Please make sure that
  API_CALL_LIMIT >= TABLE_SIZE
*/
const DEFAULT_BUILD_DATA_API_CALL_LIMIT = 50;
const DEFAULT_BUILD_DATA_TABLE_SIZE = 10;

const DEFAULT_TEST_DATA_API_CALL_LIMIT = 10;
const DEFAULT_TEST_DATA_API_CALL_LIMIT_FOR_TIMELINE_TAB_TESTVIEW = 10;
const DEFAULT_TEST_DATA_TABLE_SIZE = 10;

const DEFAULT_TEST_DATA_BYBUILD_API_CALL_LIMIT = 20;
const DEFAULT_TEST_DATA_BYBUILD_TABLE_SIZE = 10;
const MAX_LIMIT_BULK_SELECTION = 100;
/*
  Please make sure that
  API_CALL_LIMIT >= TABLE_SIZE
*/
const REQUEST_LOG_SIZE = 10;

export const BuildTestTabs = {
  BUILD_SESSIONS: 'All',
  FAILED: 'Failed',
  OTHER: 'Other',
  PASSED: 'Passed',
  RUNNING: 'Processing',
};

export const BuildTestGroups = {
  [BuildTestTabs.BUILD_SESSIONS]: [],
  Failed: [],
  Other: [
    'cancelled',
    'completed',
    'skipped',
    'unknown',
    'error',
    'lambda error',
    'ignored',
    'idle_timeout',
    'queue_timeout',
    'stopped',
  ],
  Passed: [],
  Processing: ['running', 'queued'],
};

export const TestTypes = {
  CYPRESS: 'cypress',
  HYPERTEST: 'hypertest',
  HYPERTEST_CYPRESS: 'hypertest-cypress',
  PLAYWRIGHT: 'playwright',
  SELENIUM: 'selenium',
};

export const TestCategories = {
  ANDROID: 'android',
  IOS: 'ios',
};

export const AvailableCapabilities = {
  CONSOLE: 'console',
  NETWORK: 'network',
  VIDEO: 'video',
  VISUAL: 'visual',
  TERMINAL: 'terminal',
  TELEMETRY_LOGS: 'seTelemetryLogs',
  DEVICE_LOGS: 'devicelog',
  APPIUM_LOGS: 'appiumLogs',
  ACCESSIBILITY: 'accessibility',
};

export const FrameworkDocumentationLink = {
  CYPRESS: 'https://www.lambdatest.com/support/docs/run-settings/',
  SELENIUM:
    'https://www.lambdatest.com/support/docs/selenium-automation-capabilities/',
  [AvailableCapabilities.ACCESSIBILITY]:
    'https://www.lambdatest.com/support/docs/accessibility-automation/',
};

export const LTToastDuration = 2000;

export const CapabilityDocumentationLink = {
  [AvailableCapabilities.CONSOLE]:
    'https://www.lambdatest.com/support/docs/selenium-automation-capabilities/#lambdatest-advanced-selenium-capabilities',
  [AvailableCapabilities.NETWORK]:
    'https://www.lambdatest.com/support/docs/network-throttling/#configuring-network-throttling-in-test-automation',
  [AvailableCapabilities.TERMINAL]:
    'https://www.lambdatest.com/support/docs/selenium-automation-capabilities/#lambdatest-advanced-selenium-capabilities',
  [AvailableCapabilities.TELEMETRY_LOGS]:
    'https://www.lambdatest.com/support/docs/debugging-options/#telemetry-logs',
};

export const CapabilityDocumentationLabel = {
  [AvailableCapabilities.CONSOLE]:
    'Learn how to use console logs in your automation tests capturing the logs captured for your test',
  [AvailableCapabilities.NETWORK]:
    'Learn how to use network throttling in your automation tests for responsiveness',
  [AvailableCapabilities.TERMINAL]:
    'Learn how to use Terminal logs in your automation tests capturing the logs captured for your test',
  [AvailableCapabilities.TELEMETRY_LOGS]:
    'Learn how to use Telemetry logs in your automation tests',
  [AvailableCapabilities.ACCESSIBILITY]:
    'Learn how to use Accessibility logs in your automation tests',
};

export const BrowsersMap = {
  CHROME: 'chrome',
  EDGE: 'microsoftedge',
  FIREFOX: 'firefox',
  INTERNET_EXPLORER: 'internet explorer',
  MOBILE: 'mobile',
  OPERA: 'opera',
  SAFARI: 'safari',
  YANDEX: 'yandex',
};

export const CommandLogErrorWithDescriptionMap = {
  '400 element click intercepted': {
    message: `The Element Click command could not be completed because the element receiving the events is obscuring the element that was requested clicked.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#element-click-intercepted---400`,
  },
  '400 element not interactable': {
    message: `A command could not be completed because the element is not pointer- or keyboard interactable.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#element-not-interactable---400`,
  },
  '400 insecure certificate': {
    message: `Navigation caused the user agent to hit a certificate warning, which is usually the result of an expired or invalid TLS certificate.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#insecure-certificate---400`,
  },
  '400 invalid argument': {
    message: `The arguments passed to a command are either invalid or malformed.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#invalid-argument---400`,
  },
  '400 invalid cookie domain': {
    message: `An illegal attempt was made to set a cookie under a different domain than the current page.message:`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#invalid-cookie-domain---400`,
  },
  '400 invalid element state': {
    message: `A command could not be completed because the element is in an invalid state, e.g. attempting to clear an element that isn't both editable and resettable.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#invalid-element-state---400`,
  },
  '400 invalid selector': {
    message: `Argument was an invalid selector.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#invalid-selector---400`,
  },
  '404 invalid session id': {
    message: `Occurs if the given session id is not in the list of active sessions, meaning the session either does not exist or that it's not active.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#the-case-where-session-not-generated---invalid-session-id-404-session-not-created-500`,
  },
  '404 stale element reference': {
    message: `A command failed because the referenced element is no longer attached to the DOM.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#stale-element-reference---404`,
  },
  '404 detached shadow root': {
    message: `A command failed because the referenced shadow root is no longer attached to the DOM.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/`,
  },
  '404 unknown command': {
    message: `A command could not be executed because the remote end is not aware of it.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#unknown-command---404`,
  },
  '404 no such alert': {
    message: `An attempt was made to operate on a modal dialog when one was not open.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#no-such-alert---404`,
  },
  '404 no such cookie': {
    message: `No cookie matching the given path name was found amongst the associated cookies of the current browsing context's active document.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#no-such-cookie---404`,
  },
  '404 no such element': {
    message: `An element could not be located on the page using the given search parameters.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#no-such-element---404`,
  },
  '404 no such frame': {
    message: `A command to switch to a frame could not be satisfied because the frame could not be found.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#no-such-frame---404`,
  },
  '404 no such window': {
    message: `A command to switch to a window could not be satisfied because the window could not be found.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#no-such-window---404`,
  },
  '404 no such shadow root': {
    message: `The element does not have a shadow root.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#no-such-shadow-root---404`,
  },
  '405 unknown method': {
    message: `The requested command matched a known URL but did not match any method for that URL.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#unknown-method---405`,
  },
  '500 javaScript error': {
    message: `An error occurred while executing JavaScript supplied by the user.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#javascript-error---500`,
  },
  '500 move target out of bounds': {
    message: `The target for mouse interaction is not in the browser’s viewport and cannot be brought into that viewport.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#move-target-out-of-bounds---500`,
  },
  '500 script timeout error': {
    message: `A script did not complete before its timeout expired.`,
    link: `https://www.lambdatest.com/support/docs/timeouts-issues-and-resolutions/`,
  },
  '500 session not created': {
    message: `A new session could not be created.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#the-case-where-session-not-generated---invalid-session-id-404-session-not-created-500`,
  },
  '500 timeout': {
    message: `An operation did not complete before its timeout expired`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#script-timeout---500`,
  },
  '500 unable to set cookie': {
    message: `A command to set a cookie's value could not be satisfied.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#unable-to-set-cookies---500`,
  },
  '500 unable to capture screen': {
    message: `A screen capture was made impossible.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#unable-to-capture-screen---500`,
  },
  '500 unexpected alert open': {
    message: `A modal dialog was open, blocking this operation.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#unexpected-alert-open---500`,
  },
  '500 unknown error': {
    message: `An unknown error occurred in the remote end while processing the command`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#unknown-error---500`,
  },
  '500 unsupported operation': {
    message: `Indicates that a command that should have executed properly cannot be supported for some reason.`,
    link: `https://www.lambdatest.com/support/docs/error-messages/#unsupported-operation---500`,
  },
};

export const DEFAULT_COMMAND_LOG_SIZE = 20;
export const DEFAULT_CDP_COMMAND_LOG_SIZE = 50;

export {
  Const_BuildView,
  Const_TestView,
  CONST_BUILDVIEW,
  CONST_TESTVIEW,
  DEFAULT_VIEW_TIMELINE,
  DEFAULT_VIEW_ANALYTICS,
  DEFAULT_VIEW_AUTOMATION,
  TIME_SPAN_TODAY,
  TIME_SPAN_MONTH,
  TIME_SPAN_WEEK,
  TIME_SPAN_RANGE,
  DEFAULT_TIME_SPAN_FILTER,
  DEFAULT_BUILD_DATA_API_CALL_LIMIT,
  DEFAULT_TEST_DATA_API_CALL_LIMIT,
  DEFAULT_TEST_DATA_BYBUILD_API_CALL_LIMIT,
  DEFAULT_BUILD_DATA_TABLE_SIZE,
  DEFAULT_TEST_DATA_TABLE_SIZE,
  DEFAULT_TEST_DATA_BYBUILD_TABLE_SIZE,
  REQUEST_LOG_SIZE,
  MAX_LIMIT_BULK_SELECTION,
  DEFAULT_TEST_DATA_API_CALL_LIMIT_FOR_TIMELINE_TAB_TESTVIEW,
};

export const NetworkLogsFilterList = [
  {
    name: 'All',
    value: 'all',
  },
  {
    name: 'JS',
    value: 'js',
  },
  {
    name: 'CSS',
    value: 'css',
  },
  {
    name: 'Img',
    value: 'img',
  },
  {
    name: 'Media',
    value: 'media',
  },
  {
    name: 'Doc',
    value: 'doc',
  },
];

export const HOME_AND_SMARTUI_TAB_ID_PREFIX =
  'controlled-tab-example-network-tab';

export const NETWORK_TAB_ID_PREFIX = 'lt-test-detail-network-tab-filter-value';

export const TEST_DETAIL_ID_PREFIX = 'lt-test-detail';

export const LOGS_AND_METADATA_TAB_ID_PREFIX =
  'controlled-tab-example-network-tab';

export const SELENIUM_KEY = 'selenium';

export const BASIC_INFO_KEY = 'basic_info';

export const TestDetailInitialTabId = {
  home: `${TEST_DETAIL_ID_PREFIX}-all-commands-tab-search`,
  network: `${NETWORK_TAB_ID_PREFIX}-${NetworkLogsFilterList[0].value}`,
  logs: (selectedTabSubType = SELENIUM_KEY) =>
    `${TEST_DETAIL_ID_PREFIX}-logs-${selectedTabSubType}`,
  'meta-data': (selectedTabSubType = BASIC_INFO_KEY) =>
    `${TEST_DETAIL_ID_PREFIX}-metadata-${selectedTabSubType}`,
  'smart-ui': `${HOME_AND_SMARTUI_TAB_ID_PREFIX}-smart-ui-button`,
};

export const DEFAULT_HE_TAG_NAME = 'he_run:latest';

export const SELENIUM_CONSOLE_LOG_TYPE = 'console';

export const DemoTestIds = [
  // Stage builds (3615750, 3615720, 3615694)
  'DA-WIN-33645026-1761034416140000280TPS',
  'DA-WIN-33645026-1761034483643309794TAS',
  'DA-WIN-33645026-1761034515883520941UKK',
  'DA-MAC-33645026-1761034665452040389AGF',
  'DA-MAC-33645026-1761034807192067289DBJ',
  'DA-WIN-33645026-1761034714383587573YPD',
  'MA-AND-33645026-1761034877398172754XJR',
  'DA-MAC-33645026-1761035103357469186SZM',
  'DA-MAC-33645026-1761035218374633133KFX',
  'MA-AND-33645026-1761035012227278941KFL',

  // Prod builds (67218025, 67216185, 67215333)
  'DA-WIN-2851933-1761030922716429323ETX',
  'DA-WIN-2851933-1761030952987486657HIJ',
  'DA-WIN-2851933-1761030977721813118YCF',
  'DA-MAC-2851933-1761031545362521308OON',
  'MA-AND-2851933-1761031771840226924FDK',
  'DA-MAC-2851933-1761033227909926663NAM',
  'DA-MAC-2851933-1761033468808251395YPY',
  'DA-MAC-2851933-1761033945031409939PFD',
  'DA-WIN-2851933-1761033314705569496RQU',
  'DA-WIN-2851933-1761033392144207604SBI',
  'DA-WIN-2851933-1761033883722656708AWN',
  'MA-AND-2851933-1761033517626056455FIQ',
];
